import { GetterTree } from "vuex";
import { DatasetState, DensityType } from "./types";
import { RootState } from "../types";

export const getters: GetterTree<DatasetState, RootState> = {
    type(state): DensityType {
        return state.type;
    },
    legendUpdate: (state) => state.legendUpdate,
};
